import ComparisonRow from "./ComparisonRow";

interface TotalAPIRequestCountRowProps {
  totalStagedAPIRequests?: number;
  totalPublishedAPIRequests?: number;
}

const TotalAPIRequestCountRow = ({
  totalStagedAPIRequests,
  totalPublishedAPIRequests,
}: TotalAPIRequestCountRowProps) => {
  return (
    <ComparisonRow
      label="API Requests"
      stagedValue={totalStagedAPIRequests}
      publishedValue={totalPublishedAPIRequests}
    />
  );
};

export default TotalAPIRequestCountRow;
